import React from 'react';

import { RatingFilterValues } from 'apis/merchant-gateway/insights/reviews/types';
import MonetaryAmount from 'common/formatting/MonetaryAmount';
import { convertMonetaryIntToDecimal } from 'common/utils/currencyDecimals';

// Hard-coded values for now, feature flag makes sure only countries with correct currency are included
export const isCompensationOfferAvailable = (rating: number) => rating <= 3;
export const badRatingsFilter: RatingFilterValues[] = ['rating_1', 'rating_2', 'rating_3'];

type AvailableOffer = { amount: number; currency: Currency; validityInDays: number };
const availableOffers: AvailableOffer[] = [
  {
    amount: 2000,
    currency: 'DKK',
    validityInDays: 14,
  },
  {
    amount: 300,
    currency: 'EUR',
    validityInDays: 14,
  },
];
export const getAvailableOfferForCurrency = (currency: Currency): AvailableOffer | undefined =>
  availableOffers.find(offer => offer.currency === currency);

/** A helper wrapper on top of MonetaryAmount for displaying compact currency values for offers */
export const OfferMonetaryAmount = ({ amount, currency }: { amount: number; currency: Currency }) => {
  return (
    <MonetaryAmount
      amount={convertMonetaryIntToDecimal(amount, currency)}
      currency={currency}
      numberFormatOptions={{ minimumFractionDigits: 0 }}
    />
  );
};
